__turbopack_context__.v({
  "btn": "service-module-scss-module__GNZ8Ga__btn",
  "categoriesSlider": "service-module-scss-module__GNZ8Ga__categoriesSlider",
  "categoriesSlider__swiper": "service-module-scss-module__GNZ8Ga__categoriesSlider__swiper",
  "features": "service-module-scss-module__GNZ8Ga__features",
  "features__item": "service-module-scss-module__GNZ8Ga__features__item",
  "footer": "service-module-scss-module__GNZ8Ga__footer",
  "helperBlock__link": "service-module-scss-module__GNZ8Ga__helperBlock__link",
  "helperBlock__workingHours": "service-module-scss-module__GNZ8Ga__helperBlock__workingHours",
  "img": "service-module-scss-module__GNZ8Ga__img",
  "modal": "service-module-scss-module__GNZ8Ga__modal",
  "plasticCards": "service-module-scss-module__GNZ8Ga__plasticCards",
  "plasticCards__button": "service-module-scss-module__GNZ8Ga__plasticCards__button",
  "promo": "service-module-scss-module__GNZ8Ga__promo",
  "section": "service-module-scss-module__GNZ8Ga__section",
  "section_hint": "service-module-scss-module__GNZ8Ga__section_hint",
  "slider": "service-module-scss-module__GNZ8Ga__slider",
  "subtitle": "service-module-scss-module__GNZ8Ga__subtitle",
  "title": "service-module-scss-module__GNZ8Ga__title",
  "wrapper": "service-module-scss-module__GNZ8Ga__wrapper",
});
